import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import {ServiceResponse} from "../../../../../app/services/shared/interfaces";
import {AppContext} from "../../../../../contexts/AppContext";
import useEventGuestService from "../../../../../app/services/intranet_company/hooks/useEventGuestService";
import {EventGuest, EventGuestFilters} from "../../../../../app/models/EventGuest";
import useReactConfirmAlert from "../../../../../hooks/useReactConfirmAlert";
import DefaultCard from "../../../../../components/default/DefaultCard";
import ButtonCreate from "../../../../../components/buttons/ButtonCreate";
import EventGuestDataTable from "./tablas/EventGuestDataTable";
import DefaultModal from "../../../../../components/default/DefaultModal";
import EventGuestCreate from "./EventGuestCreate";
import EventGuestEdit from "./EventGuestEdit";

interface Props {
    eventId: number;
}

const EventGuestContainer = ({ eventId }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const {
        getEventGuestsByEvent,
        deleteEventGuest,
        showEventGuest,
        fetchingGetEventGuestsByEvent,
        fetchingDeleteEventGuest,
        fetchingShowEventGuest
    } = useEventGuestService();

    const [showingEdit, setShowingEdit] = useState(false);
    const [showingCreate, setShowingCreate] = useState(false);
    const [showingShow, setShowingShow] = useState(false);

    const [eventGuestIdEdit, setEventGuestIdEdit] = useState<number>(-1);
    const [eventGuestIdShow, setEventGuestIdShow] = useState<number>(-1);

    const [eventGuests, setEventGuests] = useState<EventGuest[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);

    const [filter, setFilter] = useState<EventGuestFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'desc'
    });

    const [errorFields, setErrorFields] = useState<any>();

    useEffect(() => {
        reloadTable();
    }, [filter]);

    const reloadTable = () => {
        getEventGuestsByEvent(eventId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setEventGuests(response.data.eventGuests);
                setTotalRows(response.data.total_rows);
            },
            onError: (response: ServiceResponse) => {
                toast.error(response.message);
            }
        });
    };

    const showCreate = () => {
        setShowingCreate(true);
    };

    const hideCreate = () => {
        setShowingCreate(false);
    };

    const showEdit = (eventGuestId: number) => {
        setShowingEdit(true);
        setEventGuestIdEdit(eventGuestId);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setEventGuestIdEdit(-1);
    };

    const hideShow = () => {
        setShowingShow(false);
        setEventGuestIdShow(-1);
    };


    const destroy = (eventGuestId: number) => {
        const _text = 'Está a punto de eliminar el invitado #' + eventGuestId;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: _text,
            buttons: {
                confirmButton: {
                    label: 'Si, confirmar',
                    onClick: () => {
                        if (showLoading) showLoading('loading', 'Eliminando invitado...');
                        deleteEventGuest(eventGuestId, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'No, cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El invitado no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    const showEventGuestDetail = (eventGuestId: number) => {
        if (showLoading) showLoading('loading', 'Cargando detalles del invitado...');
        showEventGuest(eventGuestId, {
            onSuccess: (response: ServiceResponse) => {
                setEventGuestIdShow(eventGuestId);
                setShowingShow(true);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                hideShow(); // Oculta el modal si ocurre un error
            }
        });
    };

    return (
        <>
            <DefaultCard>
                <div className="row">
                    <div className="col-12 mb-2 mt-2">
                        <ButtonCreate title="Nuevo Invitado" callbackCreate={showCreate} />
                    </div>
                    <div className="col-12">
                        <EventGuestDataTable
                            loading={fetchingGetEventGuestsByEvent}
                            eventGuests={eventGuests}
                            totalRows={totalRows}
                            callbackSuccess={reloadTable}
                            edit={showEdit}
                            destroy={destroy}
                            filter={filter}
                            setFilter={setFilter}
                            show={showEventGuestDetail}
                        />
                    </div>
                </div>
            </DefaultCard>
            {showingCreate ? (
                <DefaultModal
                    show={showingCreate}
                    handleClose={hideCreate}
                    title="Crear Invitado"
                    backdrop={true}
                    showFooter={false}
                >
                    <EventGuestCreate
                        eventId={eventId}
                        onSaved={() => {
                            reloadTable();
                            hideCreate();
                        }}
                        onCancel={hideCreate}
                        onError={hideCreate}
                    />
                </DefaultModal>
            ) : null}

            {showingEdit ? (
                <DefaultModal
                    show={showingEdit}
                    handleClose={hideEdit}
                    title="Editar Invitado"
                    backdrop={true}
                    showFooter={false}
                >
                    <EventGuestEdit
                        eventGuestId={eventGuestIdEdit}
                        transportOrderId={eventId}
                        onSaved={() => {
                            reloadTable();
                            hideEdit();
                        }}
                        onCancel={hideEdit}
                        onError={hideEdit}
                    />
                </DefaultModal>
            ) : null}
        </>
    );
};

export default EventGuestContainer;
